import React, { useEffect, useRef } from "react";
import Slider from "react-slick";

const InstagramSection = () => {
  const sliderRef = useRef(null);
  const pauseSlider = () => sliderRef.current?.slickPause();
  const playSlider = () => sliderRef.current?.slickPlay();
  const NextArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      type='button'
      id='feature-item-wrapper-next'
      className='slick-next slick-arrow flex-center rounded-circle border border-gray-100 bg-white text-xl hover-bg-main-600 hover-text-white transition-1'
    >
      <i className='ph ph-caret-right' />
    </button>
  );

  const PrevArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      type='button'
      id='feature-item-wrapper-prev'
      className='slick-prev slick-arrow flex-center rounded-circle border border-gray-100 bg-white text-xl hover-bg-main-600 hover-text-white transition-1'
    >
      <i className='ph ph-caret-left' />
    </button>
  );
  const settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    speed: 1000,
    dots: false,
    pauseOnHover: true,
    pauseOnFocus: true,
    arrows: true,
    draggable: true,
    infinite: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1299,
        settings: {
          slidesToShow: 3,
          arrows: false,
          autoplay: true,
          draggable: true,
          swipe: true,
          touchMove: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          arrows: false,
          autoplay: true,
          draggable: true,
          swipe: true,
          touchMove: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          arrows: false,
          autoplay: true,
          draggable: true,
          swipe: true,
          touchMove: true,
        },
      },
      {
        breakpoint: 424,
        settings: {
          slidesToShow: 1,
          arrows: false,
          autoplay: true,
          draggable: true,
          swipe: true,
          touchMove: true,
        },
      },
    ],
  };

  const reels = [
    "https://www.instagram.com/reel/DYhRjNeT_NK/",
    "https://www.instagram.com/reel/DYbDE_PzYIP/",
    "https://www.instagram.com/reel/DYV22OYzAtY/",
    "https://www.instagram.com/reel/DYQr-SBTkpK/",
    "https://www.instagram.com/reel/DYKHbKIzMok/",
  ];

  useEffect(() => {
    const scriptId = "instagram-embed-script";
    const existing = document.getElementById(scriptId);
    if (!existing) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.async = true;
      script.src = "//www.instagram.com/embed.js";
      script.onload = () => {
        if (window.instgrm && window.instgrm.Embeds) {
          window.instgrm.Embeds.process();
        }
      };
      document.body.appendChild(script);
    } else if (window.instgrm && window.instgrm.Embeds) {
      window.instgrm.Embeds.process();
    }
  }, []);

  useEffect(() => {
    const handleBlur = () => {
      // Pause slider when user clicks inside an iframe (e.g., Instagram embed)
      pauseSlider();
    };
    const handleFocus = () => {
      // Resume slider when user returns to the page
      playSlider();
    };
    window.addEventListener("blur", handleBlur);
    window.addEventListener("focus", handleFocus);
    return () => {
      window.removeEventListener("blur", handleBlur);
      window.removeEventListener("focus", handleFocus);
    };
  }, []);
  return (
    <section className='instagram py-120 overflow-hidden'>
      <div className='container container-lg'>
        <div className='section-heading'>
          <div className='flex-between flex-wrap gap-8'>
            <div className=''>
              <h5 className='mb-0 text-uppercase'>Instagram</h5>
            </div>
            <div className='flex-align gap-16'>
              <a
                href='https://www.instagram.com/vedhasculture'
                target='_blank'
                rel='noreferrer'
                className='text-sm fw-semibold text-gray-700 hover-text-main-600 hover-text-decoration-underline'
              >
                View All
              </a>
              <div className='flex-align gap-8'></div>
            </div>
          </div>
        </div>
        <div
          className='instagram-slider'
          onMouseEnter={pauseSlider}
          onMouseLeave={playSlider}
          onTouchStart={pauseSlider}
          onTouchEnd={playSlider}
        >
          <Slider ref={sliderRef} {...settings}>
            {reels.map((src) => (
              <div key={src}>
                <div
                  className='instagram-item rounded-24 overflow-hidden position-relative'
                  // style={{ aspectRatio: "9 / 16", minHeight: 1900 }}
                  onFocus={pauseSlider}
                  onBlur={playSlider}
                  tabIndex={0}
                >
                  <blockquote
                    className='instagram-media'

                    data-instgrm-permalink={`${src}?utm_source=ig_embed&utm_campaign=loading`}
                    data-instgrm-version='14'
                    style={{
                      background: "#fff",
                      border: 0,
                      borderRadius: 3,
                      margin: "1px",
                      width: "100%",
                    }}
                  >
                    <a
                      href={`${src}?utm_source=ig_embed&utm_campaign=loading`}
                      target='_blank'
                      rel='noreferrer'
                      style={{
                        background: "#fff",
                        color: "inherit",
                        display: "block",
                        textAlign: "center",
                        textDecoration: "none",
                        width: "100%",
                      }}
                    >
                      View this post on Instagram
                    </a>
                  </blockquote>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default InstagramSection;
